<script lang="ts" setup>
const isSticky = ref(false)
let throttleTimer: NodeJS.Timeout | null = null
const handleScroll = () => {
    isSticky.value = window.scrollY > 10
    if (throttleTimer) return
    throttleTimer = setTimeout(() => {
        throttleTimer = null
    }, 100)
}
onMounted(() => {
    window.addEventListener('scroll', handleScroll, {passive: true})
})
onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll)
    if (throttleTimer) clearTimeout(throttleTimer)
})
</script>

<template>
  <header
    :class="{ 'header-sticky':  isSticky}"
    class="container transition-all rounded-b-2xl rounded-t-0 text-center flex justify-between mb-0 laptop:sticky laptop:top-0 laptop:z-10 laptop:bg-white/95">
      <SiteLogo />
      <SiteMobileMenuButton/>
      <SiteNav />
  </header>
</template>

<style scoped>
</style>